import { DemandsRow } from './../models/demands-row';
import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import { TaxReceiptRow } from '@common/models/tax-receipt-row';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from './url-builder.service';

@Injectable()
export class InvoiceAndReceiptsService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService
  ) { }

  getDemands(demandType, invoiceRef): Observable<DemandsRow[]> {
    const url = this.urlBuilder.getUrl(`demands/${demandType}/copy/${encodeURIComponent(invoiceRef)}`);
    return this.http.get<DemandsRow[]>(url);
  }

  getTaxReceipts(invoiceRef): Observable<TaxReceiptRow[]> {
    const url = this.urlBuilder.getUrl(`tax-receipt/${invoiceRef}/copy`);
    return this.http.get<TaxReceiptRow[]>(url);
  }
}
